import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@chakra-ui/react'

const CustomLink = ({ onClick, ...props }) => {
  return (
    <Box
      flex="1"
      textAlign="left"
      textStyle="link"
      cursor="pointer"
      {...props}
    >
      <span onClick={onClick}>{props.children}</span>
    </Box>
  )
}

CustomLink.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.any,
}

export default CustomLink
